import { City, State, Bank, User, Course } from '@app/admin/model';
import { Base } from "@app/shared/model";

export class Teacher extends Base {
    name: string;
    birthDate: Date;
    email: string;
    phone: string;
    cpf: string;
    zipCode: string;
    street: string;
    number: string;
    complement: string;
    neighborhood: string;
    
    cityId: number;
    cityName: string;
    city: City;
    
    stateId: number;
    stateUf: string;
    state: State;

    country: string;
    
    bankId: number;
    bank: Bank;
    accountType: number;
    agency: string;
    account: string;
    pix: string;

    hourlyRate: number;

    userId: number;
    user: User;
    haveUser: boolean;
    
    universityGraduate: string;
    moreInformation: string;

    haveNewMessage: boolean;
    lastMessageDatetime: Date;

    courses: Array<Course>;

    constructor(contentResponse: any) {
        if (contentResponse) {
            super(contentResponse);
        
            this.name = contentResponse.name;
            this.birthDate = new Date(contentResponse.birthDate),
            this.email = contentResponse.email;
            this.phone = contentResponse.phone;
            this.cpf = contentResponse.cpf;
            this.zipCode = contentResponse.zipCode;
            this.street = contentResponse.street;
            this.number = contentResponse.number;
            this.complement = contentResponse.complement;
            this.neighborhood = contentResponse.neighborhood;
            this.country = contentResponse.country;
    
            this.universityGraduate = contentResponse.universityGraduate;
            this.moreInformation = contentResponse.moreInformation;
    
            this.accountType = parseInt(contentResponse.accountType);
            this.agency = contentResponse.agency;
            this.account = contentResponse.account;
            this.pix = contentResponse.pix;
            this.hourlyRate = contentResponse.hourlyRate;
            
            this.stateId = parseInt(contentResponse.stateId);
            this.stateUf = contentResponse.stateUf;
            if (contentResponse.stateId > 0 && contentResponse.state) {
                this.state = contentResponse.state;
            }
    
            this.cityId = parseInt(contentResponse.cityId);
            this.cityName = contentResponse.cityName;
            if (contentResponse.cityId > 0 && contentResponse.city) {
                this.city = contentResponse.city;
            }

            this.bankId = parseInt(contentResponse.bankId);
            if (contentResponse.bankId > 0 && contentResponse.bank) {
                this.bank = contentResponse.bank;
            }

            this.userId = parseInt(contentResponse.userId);
            if (contentResponse.userId > 0 && contentResponse.user) {
                this.user = contentResponse.user;
            }
            
            this.haveUser = contentResponse.haveUser;
            this.haveNewMessage = contentResponse.haveNewMessage;
            this.lastMessageDatetime = new Date(contentResponse.lastMessageDatetime);

            if(contentResponse.courses && contentResponse.courses.lenght > 0) {
                this.courses = contentResponse.courses;
            }
        }
    }
}
